const dynamicPhoto = {
  UltTitle: 'HitPaw Animar Fotos Antiguas Online',
  priceWeek: '3,99€',
  priceMonth: '1,99€',
  priceYear: '0,99€',
  week: 'Semana',
  Monthly: 'Mensualmente',
  Weekly: 'Semanalmente',
  Yearly: 'Anualmente',
  monthTotalPrice: '7,99€ Pagado Mensualmente',
  yearTotalPrice: '47,99€ Pagado Anualmente',
  NoImageSizeLimits: 'Cargar imágenes sin límite de tamaño',
  UnlimitedImageUploads: 'Imágenes Cargas Ilimitadas',
  DownloadWithoutWatermark: 'Descargar Imagen HD Sin Marca de Agua',
  DownloadGif: 'Descargar Videos en formato GIF',
};

export default dynamicPhoto;
